import { atom, useAtomValue, useSetAtom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { cloneDeep, merge } from 'lodash-es';
import { useCallback, useMemo } from 'react';
import { DeepPartial } from 'react-hook-form';
import { IField } from '../../../data-models/field2.data-model';
import { useKpiConfigSchema } from '../../../schemas/KpiConfigForm.schema';
import { kpiConfigByIdMapAtom } from '../../../services/state/KPIConfigState';

export const selectedKpiConfigIdAtom = atom<number | null>(null);
export const selectedKpiConfigAtom = atom((get) => {
  const kpiConfigsById = get(unwrap(kpiConfigByIdMapAtom));
  const selectedKpiConfigId = get(selectedKpiConfigIdAtom);
  return selectedKpiConfigId ? (kpiConfigsById?.get(selectedKpiConfigId) ?? null) : null;
});

export const showKpiConfigFormAtom = atom(false);

export function useResetKpiConfigFormState() {
  const setSelectedKpiConfigId = useSetAtom(selectedKpiConfigIdAtom);
  const setShowKpiConfigForm = useSetAtom(showKpiConfigFormAtom);
  return useCallback(() => {
    setSelectedKpiConfigId(null);
    setShowKpiConfigForm(false);
  }, [setSelectedKpiConfigId, setShowKpiConfigForm]);
}

export function useKpiConfigFormDefaults(
  createOverrides?: DeepPartial<IField<unknown>>
): Partial<IField<unknown>> | undefined {
  const selectedKpiConfig = useAtomValue(selectedKpiConfigAtom);
  const schema = useKpiConfigSchema();
  return useMemo(() => {
    if (selectedKpiConfig) {
      return cloneDeep(selectedKpiConfig);
    }
    if (!createOverrides) {
      return undefined;
    }
    return merge({}, schema.getDefault(), createOverrides) as Partial<IField<unknown>>;
  }, [selectedKpiConfig, schema, createOverrides]);
}
